import React from "react";

import { Link } from "react-router-dom";
import { Trans } from "react-i18next";
import LazyImage from "../Shared/LazyImage";
import LoadingOverlay from "../Loaders/LoadingOverlay";

const UserProfileView = ({ user, setEditMode, isLoading }) => {
    return (
        <>
            <div className="card-table shadow">
                <LoadingOverlay active={isLoading}>
                    <div className="upload-img-box flex">
                        <div className="choose-img-wrapper">
                            <LazyImage
                                src={
                                    user?.image ||
                                    require("../../assets/images/no-avatar.png")
                                        .default
                                }
                                alt="Upload avatar"
                            />
                        </div>
                        <div className="w-full">
                            <div className="flex justify-between">
                                <h3 className="medium-title-bold mr-2">
                                    <Trans i18nKey="personalInformation">
                                        Personal Information
                                    </Trans>
                                </h3>
                                <div className="text-primary-blue cursor-pointer">
                                    <i
                                        onClick={() => {
                                            setEditMode(true);
                                        }}
                                        className="fas fa-edit"
                                    ></i>
                                </div>
                            </div>

                            <hr className="mt-2 mb-5" />
                            <div className="flex flex-column-start-mobile">
                                <div className="tags mb-6 w-full">
                                    <h4 className="uppercase text-xs">
                                        <Trans i18nKey="firstName">
                                            Firstname
                                        </Trans>
                                    </h4>
                                    <p className="w-full">
                                        {user?.firstname ||
                                            "No Firstname Found"}
                                    </p>
                                </div>
                                <span className="mx-2"></span>
                                <div className="tags mb-6 w-full">
                                    <h4 className="uppercase text-xs">
                                        <Trans i18nKey="lastName">
                                            Lastname
                                        </Trans>
                                    </h4>
                                    <p className="w-6/12 text-justify">
                                        {user?.lastname || "No Lastname Found"}
                                    </p>
                                </div>
                            </div>
                            <div className="tags mb-6">
                                <h4 className="uppercase text-xs">
                                    <Trans i18nKey="email">Email</Trans>
                                </h4>
                                {user?.email ? (
                                    <Link
                                        to="#"
                                        onClick={(e) => {
                                            window.location = `mailto:${user.email}`;
                                            e.preventDefault();
                                        }}
                                    >
                                        <p className="w-full underline text-blue-600">
                                            {user.email}
                                        </p>
                                    </Link>
                                ) : (
                                    <p>
                                        <Trans i18nKey="noEmailFound">
                                            No Email Found
                                        </Trans>
                                    </p>
                                )}
                            </div>
                            <div className="tags mb-6">
                                <h4 className="uppercase text-xs">
                                    <Trans i18nKey="affiliate">Affiliate</Trans>
                                </h4>
                                <p className="w-full capitalize">
                                    {user?.organization?.name ||
                                        "No Organization Found"}
                                </p>
                            </div>
                            <div className="tags">
                                <h4 className="uppercase text-xs">
                                    <Trans i18nKey="role">Role</Trans>
                                </h4>
                                <p className="w-full">
                                    {user?.role || "No Role Found"}
                                </p>
                            </div>
                        </div>
                    </div>
                </LoadingOverlay>
            </div>
        </>
    );
};

export default UserProfileView;
